const TrackingEventsConstants = {
  OPEN_ADD_PROPERTY_MODAL: 'openAddPropertyModal',
  COMPLETE_ONBOARDING_FLOW: 'completeOnBoardingFlow',
  ACKNOWLEDGE_PAYMENTS_AGGREGATE_MODAL: 'openPaymentsAggregatedViewModal',
} as const;

export default TrackingEventsConstants;
